import { Component } from "@angular/core";
import { BadgeComponent } from "@husbanken/designsystem-angular-core";

@Component({
  selector: "bko-slik-fungerer-boligkompasset",
  imports: [BadgeComponent],
  templateUrl: "./slik-fungerer-boligkompasset.html",
  styleUrl: "./slik-fungerer-boligkompasset.scss",
})
export class SlikFungererBoligkompasset {}
